import { rem } from '@core-web/typography';
import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)(({ theme: { palette, breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${rem(64) + ' ' + rem(24)}`,
  backgroundColor: palette.colors.white,
  boxShadow: palette.boxShadow.modalShadow,
  borderRadius: rem(12),
  width: rem(600),
  gap: rem(16),
  [breakpoints.down(700)]: {
    width: '80%',
  },
}));

export const ModalHeader = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

export const ModalIconWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  color: palette.colors.green_600,
  fontSize: rem(64),

  ' svg': {
    fontSize: 'inherit',
  },
  '&.danger': {
    color: palette.error.main,
  },
}));
